const translations = {
  currentLanguage: 'Текущий язык',
}

export default translations
